import React from 'react';
import { Phone, Zap, Trophy, Target, TrendingUp } from 'lucide-react';
import Container from '../Container';
import Button from '../Button';

const TikTokLanding = () => {
  const features = [
    {
      icon: Zap,
      title: "Quick Results",
      description: "See rankings improve in weeks"
    },
    {
      icon: Trophy,
      title: "Best in Raleigh",
      description: "Top-rated SEO agency"
    },
    {
      icon: Target,
      title: "Local Focus",
      description: "Triangle area specialists"
    },
    {
      icon: TrendingUp,
      title: "Proven Growth",
      description: "500+ success stories"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-500 via-purple-500 to-blue-500 text-white">
      <Container>
        <div className="pt-32 pb-20">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              🔥 Viral TikTok Offer: First Month $99
            </div>

            <h1 className="text-6xl font-bold mb-6">
              Rank Your Business
              <span className="block text-pink-200">#1 on Google</span>
            </h1>

            <p className="text-xl text-white/90 mb-4">
              The secret SEO strategy that's helping Raleigh businesses go viral on Google
            </p>

            <a href="tel:9192714871" className="flex items-center justify-center text-2xl text-white font-bold mb-8 hover:text-pink-200">
              <Phone className="h-6 w-6 mr-2" />
              (919) 271-4871
            </a>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className="bg-white/10 backdrop-blur-sm p-4 rounded-xl"
                >
                  <feature.icon className="h-8 w-8 text-pink-200 mx-auto mb-2" />
                  <h3 className="font-semibold mb-1">{feature.title}</h3>
                  <p className="text-sm text-white/80">{feature.description}</p>
                </div>
              ))}
            </div>

            <div className="relative">
              <div className="absolute -inset-1 bg-gradient-to-r from-pink-400 to-purple-400 rounded-2xl blur"></div>
              <div className="relative bg-black rounded-2xl p-8">
                <h2 className="text-2xl font-bold mb-6">
                  🚀 Limited Time Offer
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                  <div className="bg-white/10 p-4 rounded-xl">
                    <div className="text-3xl font-bold">$99</div>
                    <div className="text-sm">First Month</div>
                  </div>
                  <div className="bg-white/10 p-4 rounded-xl">
                    <div className="text-3xl font-bold">24/7</div>
                    <div className="text-sm">Support</div>
                  </div>
                  <div className="bg-white/10 p-4 rounded-xl">
                    <div className="text-3xl font-bold">100%</div>
                    <div className="text-sm">Satisfaction</div>
                  </div>
                </div>
                <form className="space-y-4">
                  <input
                    type="text"
                    placeholder="Business Name"
                    className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/60 focus:ring-2 focus:ring-pink-400 focus:border-pink-400"
                  />
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/60 focus:ring-2 focus:ring-pink-400 focus:border-pink-400"
                  />
                  <input
                    type="tel"
                    placeholder="Phone Number"
                    className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/60 focus:ring-2 focus:ring-pink-400 focus:border-pink-400"
                  />
                  <Button className="w-full text-lg py-4 bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600">
                    Claim Your $99 Offer
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TikTokLanding;